import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { UploadFiles } from "./UploadFiles";

interface Props {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  patientId?: string;
  visitId?: string;
}

/** Dialog wrapper around the shared UploadFiles box (PDF-only, 72-DPI conversion). */
export function UploadDialog({ open, onOpenChange, patientId, visitId }: Props) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-maroon-700 dark:text-amber-500">Upload documents</DialogTitle>
          <DialogDescription>
            PDF or image files. Images are converted to compressed 72&nbsp;DPI PDF before upload.
          </DialogDescription>
        </DialogHeader>
        <UploadFiles patientId={patientId} visitId={visitId} onUploaded={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  );
}
